module.exports = __webpack_public_path__ + "img/forget-passMail.ad935cbb.png";